import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/solutions.svg
 */
const IconSolutions: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M15.395 9.25a2.402 2.402 0 01-4.103 1.7 2.405 2.405 0 01-.522-2.62 2.405 2.405 0 013.92-.78c.452.451.704 1.063.705 1.7zm4.587 6.06v4.169a.897.897 0 01-.613.858L8.695 23.968a.614.614 0 01-.808-.589v-2.232H5.359a1.615 1.615 0 01-1.622-1.618v-4.44h-1.2a.783.783 0 01-.706-.412.785.785 0 01.043-.816c.343-.54.785-1.3 1.178-2.083a7.288 7.288 0 00.711-2.896l.024-.244a9.196 9.196 0 019.886-8.61 9.227 9.227 0 016.305 15.282h.004zm-.343-6.649a.442.442 0 00-.441-.44H18.19a5.685 5.685 0 00-.786-1.907l.711-.71a.425.425 0 000-.615l-.854-.833a.434.434 0 00-.614 0l-.712.712a4.874 4.874 0 00-1.906-.786V3.078a.44.44 0 00-.443-.443h-1.203a.433.433 0 00-.31.13.437.437 0 00-.127.313v1.004a5.718 5.718 0 00-1.906.786l-.712-.712a.434.434 0 00-.614 0l-.832.833a.43.43 0 000 .614l.711.711a4.901 4.901 0 00-.785 1.907H6.805a.442.442 0 00-.443.44v1.203a.441.441 0 00.443.442H7.81c.144.678.41 1.324.785 1.907l-.711.71a.43.43 0 000 .614l.834.835a.436.436 0 00.473.095.436.436 0 00.141-.095l.712-.713a4.856 4.856 0 001.906.785v1.007a.437.437 0 00.437.44h1.203a.441.441 0 00.443-.44v-1.007a5.718 5.718 0 001.906-.785l.711.713a.428.428 0 00.615 0l.834-.835a.43.43 0 000-.614l-.713-.71a4.837 4.837 0 00.785-1.907h1.007a.434.434 0 00.311-.13.441.441 0 00.127-.312V8.66h.024z"
      fill="currentColor"
    />
  </svg>
);

export default IconSolutions;
